import {useState} from "react"
import CreateListGroup from "./CreateListGroup";
import MoreInfoBox from "./MoreInfo";
import SearchItem from "./SearchItem";

export default function ChargerDevices({jsonData, index}){
    const [displayListBlock, updateListBlock] = useState({
      "current":"streaming",
      "streaming":"flex",
      "smartTV":"none",
      "gaming":"none",
      "homeAuto":"none",
      "search": 'none'
    }) // different sub windows for each category
    const [MoreInfoBoxData, setMoreInfoBoxData] = useState({}); // more info window with generation details and release dates
    const [MoreInfoBoxDisplay, setMoreInfoBoxDisplay] = useState("none"); // display for more info window

    const setMoreInfoData = (data) => { // updates more info window, then shows it
      setMoreInfoBoxData(data);
      setMoreInfoBoxDisplay("flex");
    }
    const updateDisplayListBlock = (listBlock) => { // update displays 
      updateListBlock(displayListBlock => ({...displayListBlock, [displayListBlock["current"]]:"none"})); //set current display to none
      updateListBlock(displayListBlock => ({...displayListBlock, "current":listBlock})); // set current display to new flex item
      updateListBlock(displayListBlock => ({...displayListBlock, [listBlock]:"flex"})); // update that flex item
    }
    
    return (
      <div id='chargerDevices-deviceList-container'>
      <MoreInfoBox data={MoreInfoBoxData} display={MoreInfoBoxDisplay} setDisplay={setMoreInfoBoxDisplay}/>
      <nav className="chargerDevices-deviceList-container-nav">
        <ul id="chargerDevices-deviceList-NavItems">
          <li>
              {displayListBlock["streaming"] === "flex" && <span className='chargerDevices-deviceList-NavItems-activated'></span>}
              <button 
                className='chargerDevices-deviceList-NavItems-button' 
                style={{backgroundColor: displayListBlock["streaming"] === "flex" ? "#003366" : "#FFCC33"} /* conditional styles, check for display being flex, then apply specific style. true first, else next */ } 
                onClick={()=>{updateDisplayListBlock("streaming")}}>
                  <span style={{color: displayListBlock["streaming"] === "flex" ? "white" : "black"}}>
                    Streaming Devices
                  </span>
              </button>
          </li>
          <li>
              <button className='chargerDevices-deviceList-NavItems-button' style={{backgroundColor: displayListBlock["gaming"] === "flex" ? "#003366" : "#FFCC33"}} onClick={()=>{updateDisplayListBlock("gaming")}}>
                <span style={{color: displayListBlock["gaming"] === 'flex' ? "white" : 'black'}}>Gaming Consoles</span></button>
              {displayListBlock["gaming"] === "flex" && <span className='chargerDevices-deviceList-NavItems-activated'></span>}
          </li>
          <li>
              <button className='chargerDevices-deviceList-NavItems-button' style={{backgroundColor: displayListBlock["smartTV"] === "flex" ? "#003366" : "#FFCC33"}} onClick={()=>{updateDisplayListBlock("smartTV")}}>
                <span style={{color: displayListBlock["smartTV"] === 'flex' ? "white" : 'black'}}>Smart TVs</span></button>
              {displayListBlock["smartTV"] === "flex" && <span className='chargerDevices-deviceList-NavItems-activated'></span>}
          </li>
          <li>
              <button className='chargerDevices-deviceList-NavItems-button' style={{backgroundColor: displayListBlock["homeAuto"] === "flex" ? "#003366" : "#FFCC33"}} onClick={()=>{updateDisplayListBlock("homeAuto")}}>
                <span style={{color: displayListBlock["homeAuto"] === 'flex' ? "white" : 'black'}}>Home Automation</span></button>
              {displayListBlock["homeAuto"] === "flex" && <span className='chargerDevices-deviceList-NavItems-activated'></span>}
          </li>
          <li>
              <button
                      className='chargerDevices-deviceList-NavItems-button' 
                      style={{backgroundColor: displayListBlock["search"] === "flex" ? "#003366" : "#FFCC33"}}
                      onClick={()=>{updateDisplayListBlock("search")}}>
                    <span style={{color: displayListBlock["search"] === 'flex' ? "white" : 'black'}}>Search for Device</span>
              </button>
              {displayListBlock["search"] === "flex" && <span className='chargerDevices-deviceList-NavItems-activated'></span>}
          </li>
        </ul>
      </nav>
      <div id="chargerDevices-deviceList-listsContainer">
        <div id="streaming" className='chargerDevices-deviceList-listsInnerContainer' style={{display:displayListBlock["streaming"]}}>
            <CreateListGroup data={jsonData["Streaming"]} type={"streaming"} moreInfoSetData={setMoreInfoData}/>
        </div>
        <div id="gaming" className='chargerDevices-deviceList-listsInnerContainer' style={{display:displayListBlock["gaming"]}}>
            <CreateListGroup data={jsonData["Gaming"]} type={"gameConsoles"} moreInfoSetData={setMoreInfoData}/>
        </div>
        <div id="smartTV" className='chargerDevices-deviceList-listsInnerContainer' style={{display:displayListBlock["smartTV"]}}>
            <CreateListGroup data={jsonData["Smart TVs"]} type={"tv"} moreInfoSetData={setMoreInfoData}/>
        </div>
        <div id="homeAuto" className='chargerDevices-deviceList-listsInnerContainer' style={{display:displayListBlock["homeAuto"]}}>
            <CreateListGroup data={jsonData["Home Automation"]} type={"home"} moreInfoSetData={setMoreInfoData}/>
        </div>
        <div id="search" className='chargerDevices-deviceList-listsInnerContainer-search' style={{display:displayListBlock['search']}}>
          <SearchItem data={index} moreInfoSetData={setMoreInfoData}/>
        </div>
      </div>
    </div>
    )
  }